import { merge } from 'ramda';

import {
  LOAD_VACATIONS_REQUEST, LOAD_VACATIONS_SUCCESS, LOAD_VACATIONS_FAIL,
  CONFIRM_VACATIONS_REQUEST, CONFIRM_VACATIONS_SUCCESS, CONFIRM_VACATIONS_FAIL
} from 'src/store/actions/vacationsActions';

const initialState = {
  list: [],
  fetching: false
};

const vacationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_VACATIONS_REQUEST:
    case CONFIRM_VACATIONS_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_VACATIONS_SUCCESS:
    case CONFIRM_VACATIONS_SUCCESS:
      return merge(state, { fetching: false, list: action.vacations });
    case LOAD_VACATIONS_FAIL:
    case CONFIRM_VACATIONS_FAIL:
      return merge(state, { fetching: false });
    default:
      return state;
  }
};

export default vacationsReducer;
